import { render, staticRenderFns } from "./MilestoneListing.vue?vue&type=template&id=22e56d4d&"
import script from "./MilestoneListing.vue?vue&type=script&lang=js&"
export * from "./MilestoneListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports